export type DistributionColors = {
  savings: string
  investing: string
  bitcoin: string
  cashBalance: string
}

export const DISTRIBUTION_COLORS_LIGHT = {
  savings: '#00D64F',
  investing: '#9013FE',
  bitcoin: '#00D4FF',
  cashBalance: '#333333',
}

export const DISTRIBUTION_COLORS_DARK = {
  savings: '#00D64F',
  investing: '#9013FE',
  bitcoin: '#00D4FF',
  cashBalance: '#FFFFFF',
}
